<template>
	<div id="btn">
		<ButtonDropdown
			id="button-dropdown-kebab"
			:icon="icon"
			iconed
			:options="options"
			:width-full="false"
			@id="change($event)"
			@input="change"
		/>
	</div>
</template>

<script>
import ButtonDropdown from '../ButtonDropdown/ButtonDropdown.vue'

export default {
	name: 'KebabMenu',
	components: {
		ButtonDropdown,
	},

	props: {
		icon: {
			type: String,
			default: 'fas fa-ellipsis-v',
		},
		/**
		 * Id do componente
		 */
		disabled: Boolean,

		/**
		 * Id do componente
		 */
		id: String,
		/**
		 * Label do componente
		 */
		label: String,
		/**
		 * Placeholder do componente
		 */
		placeholder: String,
		/**
		 * Valor que sera feito o bind
		 */
		value: [Array, Object],
		/**
		 * Mascara para o campo
		 */
		mask: [String, Array],

		options: Array,
	},
	data() {
		return {
			/**
			 * intencao da lista que deverá ser tomada para determinado registro
			 */
			intent: '',
			/**
			 * id do registro em que a intenção vai ser tomada
			 */
			opcaoId: '',
		}
	},
	watch: {},
	methods: {
		change(value) {
			console.log('🚀 ~ file: KebabMenu.vue:36 ~ change ~ value', value)
			this.opcaoId = value
			this.$emit('input', {
				id: this.opcaoId,
				intent: this.opcaoId,
				properties: this.$attrs.properties,
			})
		},
	},
}
</script>

<style>
#btn {
	display: inline-block;
	width: auto !important;
}
.ui.input {
	flex-direction: column-reverse;
	width: 100%;
	margin-bottom: 0.1rem;
}

.form-input {
	font-size: 0.75rem;
}

.form-label {
	font-size: 0.75rem;
}

#button-dropdown-kebab {
	background-color: transparent !important;
	color: var(--color-gray);
}
</style>

<style scoped>
.container__buttondropdown__drop.dropdownativo {
	width: auto !important;
}
</style>
